


export const USERCHECK: string = "USERCHECK";
// export const CHECKIN: string = "CHECKIN";
// export const CHECKOUT: string = "CHECKOUT";
// export const BREACKIN: string = "BREACKIN";
// export const BREACKOUT: string = "BREACKOUT";